import React, { useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import {
  Button,
  Modal,
  Paper,
  Typography,
  Box,
  TextField,
  MenuItem,
  CircularProgress,
} from "@material-ui/core";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  createOnBoardingCategory,
  updateOnBoardingCategory,
} from "@redux/actions";
import { modalBody, modalHeader, modalStyle } from "@styles/styledComponents";

const styles = (theme) => ({
  paper: {
    boxShadow: "none !important",
  },
  form: {
    paddingRight: theme.spacing.unit * 1,
  },
  submitButton: {
    margin: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  textField: {
    marginLeft: theme.spacing.unit * 1,
    marginTop: theme.spacing.unit * 1,
  },
});

const BoardingCategoryModal = ({
  isUpdate,
  categoryModal,
  setCategoryModal,
  selectedCategory,
  setSelectedCategory,
  transitionType,
  classes,
}) => {
  const dispatch = useDispatch();
  const [category, setCategory] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);

  const createCategory = () => {
    setSelectedCategory(null);
    dispatch(createOnBoardingCategory(category)).then(() => {
      handleCloseModal();
    });
  };

  const updateCategory = () => {
    setSelectedCategory(null);
    dispatch(updateOnBoardingCategory(category)).then(() => {
      handleCloseModal();
    });
  };

  const handleSubmitForm = (event) => {
    event.preventDefault();
    setBtnLoading(true);
    isUpdate ? updateCategory() : createCategory();
  };

  function handleCategoriesInputs(event) {
    const { name, value } = event.target;
    setCategory((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  }

  function handleCloseModal() {
    setCategory({ name: "", status: true, category_type: transitionType });
    setSelectedCategory(null);
    setCategoryModal(false);
    setBtnLoading(false);
  }

  useEffect(() => {
    if (selectedCategory) {
      const { category_id, category_name, category_status } = selectedCategory;
      setCategory({
        id: category_id,
        name: category_name,
        status: category_status,
        category_type: transitionType,
      });
    } else {
      setCategory({
        name: "",
        status: true,
        category_type: transitionType,
      });
    }
  }, [selectedCategory]);

  return (
    <Modal
      open={categoryModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={modalStyle}
    >
      <Paper elevation={1} variant="normal" square>
        <div style={modalHeader}>
          <Typography variant="h5">
            {isUpdate ? "Update " : "Add "} Category
          </Typography>
        </div>
        <div style={modalBody}>
          <Paper className={classes.paper}>
            <form
              autoComplete="off"
              className={classes.form}
              onSubmit={handleSubmitForm}
            >
              <TextField
                id="category_name"
                name="name"
                label="Category Name"
                fullWidth
                required
                className={classes.textField}
                defaultValue={category.name}
                onChange={handleCategoriesInputs}
                margin="normal"
              />
              <TextField
                label="Choose Status"
                variant="standard"
                name="status"
                fullWidth
                value={category.status}
                className={classes.textField}
                onChange={handleCategoriesInputs}
                select
              >
                <MenuItem value={true}>activate</MenuItem>
                <MenuItem value={false}>deactivate</MenuItem>
              </TextField>
              <Box display="flex" justifyContent="flex-end" alignItems="center">
                {btnLoading ? (
                  <Button disabled={true} color="primary">
                    <CircularProgress />
                  </Button>
                ) : isUpdate ? (
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                  >
                    Update
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                  >
                    Create
                  </Button>
                )}

                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={handleCloseModal}
                >
                  Close
                </Button>
              </Box>
            </form>
          </Paper>
        </div>
      </Paper>
    </Modal>
  );
};

export default withStyles(styles)(BoardingCategoryModal);
